import { css } from '@emotion/react'

const S = {
  modal: css`
    width: 600px;
    height: 620px;
  `,
  header: css`
    display: flex;
    align-items: center;
    height: 72px;
    padding: 24px;
    border-bottom: 1px solid var(--Colors-Gray-400);
    font-weight: 700;
  `,
  body: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    color: var(--Colors-Gray-600);
  `,
}

export default S
